import React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import Swal from "sweetalert2";
import { saveUserQueryMessage } from "../../firebase/Firebase";

export default function Contact() {

    return (
        <div>

            <Navigation></Navigation>
            <section className="hero-wrap hero-wrap-2" style={{ backgroundImage: 'url("images/bg_2.jpg")' }} data-stellar-background-ratio="3">
                <div className="overlayy1"></div>
                <div className="container">
                    <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
                        <div className="col-md-9 ftco-animate pb-0 text-center">
                            {/* <p className="breadcrumbs"><span className="mr-2"><a href="/">Home <i className="fa fa-chevron-right"></i></a></span> <span>Contact <i className="fa fa-chevron-right"></i></span></p>
                            <h1 className="mb-3 bread">Contact</h1> */}
                            <h1 className="mb-3 bread">Contact</h1>
                            <span style={{ color: 'white' }}>YOUR NEXT CHAPTER STARTS HERE! <br />CREATING REAL VALUE IN REAL ESTATE.
</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ftco-section contact-section" style={{background:"#ebebeb"}} id="query">
                <div className="container">

                    <ContactForm></ContactForm>
                    <div className="row d-flex mb-5 contact-info justify-content-center">
                        <div className="col-md-8">
                            <div className="row mb-5">
                                <div className="col-md-4 text-center py-4">
                                    <div className="icon">
                                        <span className="fa fa-map"></span>
                                    </div>
                                    <p><span>Address:</span> 198 West 21th Street, Suite 721 New York NY 10016</p>
                                </div>
                                <div className="col-md-4 text-center border-height py-4">
                                    <div className="icon">
                                        <span className="fa fa-phone"></span>
                                    </div>
                                    <p><span>Phone:</span> <a href="tel://1234567920">+ 1235 2355 98</a></p>
                                </div>
                                <div className="col-md-4 text-center py-4">
                                    <div className="icon">
                                        <span className="fa fa-paper-plane"></span>
                                    </div>
                                    <p><span>Email:</span> <a href="mailto:info@yoursite.com">info@yoursite.com</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d109066.42047332929!2d75.50337875287556!3d31.32237873858899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5a5747a9eb91%3A0xc74b34c05aa5b4b8!2sJalandhar%2C%20Punjab!5e0!3m2!1sen!2sin!4v1608798596550!5m2!1sen!2sin"
                                width="100%" height="450" frameBorder="0" style={{border: 0}} allowFullScreen
                                aria-hidden="false" tabIndex={0}></iframe>
                            {/*<div id="map" className="bg-white"></div>*/}
                        </div>
                    </div>
                </div>
            </section>

            <Footer></Footer>

        </div>
    );

}


export class ContactForm extends React.Component<{}, {
    name: string,
    email: string,
    subject: string,
    contact: string,
    message: string,
    nameError: boolean,
    emailError: boolean,
    emailInvalidError: boolean,
    subjectError: boolean,
    contactError: boolean,
    contactErrText: string,
    messageError: boolean
}>
{
    constructor() {
        super({});
        this.nameInputElement = React.createRef<HTMLInputElement>();
        this.emailInputElement = React.createRef<HTMLInputElement>();
        this.subjectInputElement = React.createRef<HTMLInputElement>();
        this.contactInputElement = React.createRef<HTMLInputElement>();
        this.messageInputElement = React.createRef<HTMLTextAreaElement>();
    }
    nameInputElement: React.RefObject<HTMLInputElement>;
    emailInputElement: React.RefObject<HTMLInputElement>;
    subjectInputElement: React.RefObject<HTMLInputElement>;
    contactInputElement: React.RefObject<HTMLInputElement>;
    messageInputElement: React.RefObject<HTMLTextAreaElement>;


    state = {
        name: '',
        email: '',
        subject: '',
        contact: '',
        message: '',
        nameError: false,
        emailError: false,
        emailInvalidError: false,
        subjectError: false,
        contactError: false,
        contactErrText: '',
        messageError: false
    }

    validateQueryMessageData = () => {
        if (this.state.name.trim() === '') {
            if (!this.state.nameError) {
                this.setState({
                    nameError: true

                });
            }
            this.nameInputElement.current?.focus();
            return false;
        }
        else {
            if (this.state.nameError) {
                this.setState({
                    nameError: false
                });
            }
        }
        if (this.state.email.trim() === '') {
            if (!this.state.emailError) {
                this.setState({
                    emailError: true
                });
            }

            this.emailInputElement.current?.focus();
            return false;
        }
        else {
            if (this.state.emailError) {
                this.setState({
                    emailError: false
                });
            }
        }
        if (! /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(this.state.email.trim())) {
            if (!this.state.emailInvalidError) {
                this.setState({
                    emailInvalidError: true
                });
            }

            this.emailInputElement.current?.focus();
            return false;
        }
        else {
            if (this.state.emailInvalidError) {
                this.setState({
                    emailInvalidError: false
                });
            }
        }

        if (this.state.subject.trim() === '') {
            if (!this.state.subjectError) {
                this.setState({
                    subjectError: true
                });
            }

            this.subjectInputElement.current?.focus();
            return false;
        }
        else {
            if (this.state.subjectError) {
                this.setState({
                    subjectError: false
                });
            }
        }
        if (this.state.contact.trim() === '') {

                if (!this.state.contactError) {
                    this.setState({
                        contactError: true,
                        contactErrText:'Contact Field Is Required'
                    });
                }
            this.contactInputElement.current?.focus();
            return false;
            }
        else if(this.state.contact.length!==10) {


                this.setState({
                    contactError: true,
                    contactErrText:'Contact Number Must Be Of 10 Digits'
                });

            this.contactInputElement.current?.focus();
            return false;
        }

        else {
            if (this.state.contactError) {
                this.setState({
                    contactError: false
                });
            }
        }
        if (this.state.message.trim() === '') {
            if (!this.state.messageError) {
                this.setState({
                    messageError: true
                });
            }

            this.messageInputElement.current?.focus();
            return false;
        }
        else {
            if (this.state.messageError) {
                this.setState({
                    messageError: false
                });
            }
        }
        return true;
    }
    saveUserQueryMessage = () => {
        if (this.validateQueryMessageData()) {
            Swal.fire(
                {
                    title: 'Please wait',
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                    allowOutsideClick: false,

                }
            );
            saveUserQueryMessage(this.state.name, this.state.email, this.state.subject, this.state.message).then(() => {
                this.setState({
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                });
                Swal.fire(
                    {
                        title: 'Done',
                        icon: 'success',
                        text: 'We will contact you as soon as possible.',
                        allowOutsideClick: false,
                        timer: 5000,
                        timerProgressBar: true,
                        showConfirmButton: true,
                    }
                );

            }).catch(() => {
                Swal.fire(
                    {
                        title: 'Error',
                        icon: 'error',
                        text: 'Something went wrong. Please try again.',
                        allowOutsideClick: false,
                        timer: 5000,
                        timerProgressBar: true,
                        showConfirmButton: true,

                    }
                );
            });
        }
    }


    render() {

        return (
            <div className="row block-9 justify-content-center mb-5" >
                <div className="col-md-8 mb-md-5" style={{background:"#ebebeb"}}>
                    <h2 className="text-center font-weight-bold">Feel Free To Ask If Any Queries !</h2>
                    <div className="bg-light contact-form">
                        <div className="row">
                            <div className="col-lg-6 col-md-12" style={{background:"#ebebeb"}}>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Your Name" value={this.state.name} onChange={(e) => {
                                this.setState({
                                    name: e.target.value
                                });
                            }} ref={this.nameInputElement} />
                            <p style={{
                                display: this.state.nameError ? 'block'
                                    : 'none', color: 'red'
                            }}>

                                Name is required.
                                </p>
                        </div>
                            </div>
                            <div className="col-lg-6 col-md-12" style={{background:"#ebebeb"}}>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Your Email" value={this.state.email} onChange={(e) => {
                                this.setState({
                                    email: e.target.value
                                });
                            }} ref={this.emailInputElement} />
                            <p style={{
                                display: this.state.emailError ? 'block'
                                    : 'none', color: 'red'
                            }}>

                                Email is required.
                                </p>
                            <p style={{
                                display: this.state.emailInvalidError ? 'block'
                                    : 'none', color: 'red'
                            }}>

                                Email is invalid.
                                </p>
                        </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-12" style={{background:"#ebebeb"}}>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Location" value={this.state.subject} onChange={(e) => {
                                this.setState({
                                    subject: e.target.value
                                });
                            }} ref={this.subjectInputElement} />
                            <p style={{
                                display: this.state.subjectError ? 'block'
                                    : 'none', color: 'red'
                            }}>

                                Location is required.
                                </p>
                        </div>
                            </div>
                            <div className="col-lg-6 col-md-12" style={{background:"#ebebeb"}}>
                                <div className="form-group">
                                    <input type="number" className="form-control" placeholder="Contact Number" value={this.state.contact} onChange={(e) => {
                                        this.setState({
                                            contact: e.target.value
                                        });
                                    }} ref={this.contactInputElement} />
                                    <p style={{
                                        display: this.state.contactError ? 'block'
                                            : 'none', color: 'red'
                                    }}>

                                        {this.state.contactErrText}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12"  style={{background:"#ebebeb"}}>
                        <div className="form-group">
                            <textarea name="" id="" cols={5} rows={7} className="form-control" placeholder="Message"

                                onChange={(e) => {
                                    this.setState({
                                        message: e.target.value
                                    });
                                }}
                                ref={this.messageInputElement}
                                value={this.state.message}

                            ></textarea>
                            <p style={{
                                display: this.state.messageError ? 'block'
                                    : 'none', color: 'red'
                            }}>

                                Message is required.
                                </p>
                        </div>
                            </div>
                        </div>
                        <div className="form-group text-center" style={{background:"#ebebeb"}}>
                            <button onClick={

                                this.saveUserQueryMessage
                            } className="btn btn-primary py-3 px-5" >

                                Send Message
                                </button>
                        </div>
                    </div>

                </div>
            </div>




        );
    }
}